import { render, staticRenderFns } from "./MemberPaperAttach.vue?vue&type=template&id=5ac2cbd1&scoped=true&"
import script from "./MemberPaperAttach.vue?vue&type=script&lang=js&"
export * from "./MemberPaperAttach.vue?vue&type=script&lang=js&"
import style0 from "./MemberPaperAttach.vue?vue&type=style&index=0&id=5ac2cbd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2cbd1",
  null
  
)

export default component.exports